import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useContributions } from '../../hooks/useContributions';
import StatCard from '../../components/ui/StatCard';
import { fmt, fmtDate, CONTRIBUTION_TYPES } from '../../lib/constants';

export default function MemberFinancials() {
  const { member } = useAuth();
  const [year,  setYear]  = useState(new Date().getFullYear());
  const [typeF, setTypeF] = useState('');

  const { contributions, summary, loading } = useContributions(
    member ? { member_id: member.id, year, type: typeF||undefined } : {}
  );

  if (!member) return null;

  return (
    <div>
      <div className="flex-between mb-4">
        <div>
          <h1 style={{fontSize:20,fontWeight:800}}>💰 My Contributions</h1>
          <div style={{fontSize:13,color:'var(--text3)',marginTop:2}}>Your full contribution history recorded by the church</div>
        </div>
        <div className="flex gap-2">
          <select className="form-select" style={{width:'auto'}} value={year} onChange={e=>setYear(Number(e.target.value))}>
            {[2026,2025,2024,2023].map(y=><option key={y} value={y}>{y}</option>)}
          </select>
          <select className="form-select" style={{width:'auto'}} value={typeF} onChange={e=>setTypeF(e.target.value)}>
            <option value="">All Types</option>
            {CONTRIBUTION_TYPES.map(t=><option key={t}>{t}</option>)}
          </select>
        </div>
      </div>

      <div className="grid-3 mb-4">
        <StatCard icon="💰" label="Total"    value={fmt(summary.total||0)}    color="red" />
        <StatCard icon="🙏" label="Tithes"   value={fmt(summary.tithes||0)}   color="blue" />
        <StatCard icon="🎁" label="Offerings" value={fmt(summary.offerings||0)} color="green" />
      </div>

      {/* Pay CTA */}
      <div style={{background:'linear-gradient(135deg,var(--blue-dark),var(--blue))',borderRadius:12,padding:'18px 22px',color:'white',marginBottom:20,display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:12}}>
        <div>
          <div style={{fontWeight:700,fontSize:15,marginBottom:3}}>Give Online</div>
          <div style={{opacity:.75,fontSize:13}}>M-Pesa integration coming soon. Contact finance office for in-person giving.</div>
        </div>
        <button className="btn" style={{background:'rgba(255,255,255,.15)',color:'white',border:'1px solid rgba(255,255,255,.3)'}}>
          💳 Pay via M-Pesa <span style={{fontSize:11,background:'rgba(0,0,0,.2)',padding:'2px 8px',borderRadius:100,marginLeft:6}}>Coming Soon</span>
        </button>
      </div>

      {loading ? (
        <div style={{textAlign:'center',padding:32,color:'var(--text3)'}}>Loading…</div>
      ) : (
        <div className="table-wrap">
          <table>
            <thead><tr><th>Date</th><th>Type</th><th>Amount</th><th>Notes</th></tr></thead>
            <tbody>
              {contributions.length===0&&<tr><td colSpan={4} style={{textAlign:'center',padding:28,color:'var(--text3)'}}>No contributions recorded for this period</td></tr>}
              {contributions.map(c=>(
                <tr key={c.id}>
                  <td style={{whiteSpace:'nowrap'}}>{fmtDate(c.date)}</td>
                  <td><span className={`badge badge-${c.type==='Tithe'?'red':c.type==='Offering'?'blue':'green'}`}>{c.type}</span></td>
                  <td style={{fontWeight:700,color:'var(--blue-dark)'}}>{fmt(c.amount)}</td>
                  <td style={{fontSize:12,color:'var(--text3)'}}>{c.notes||'—'}</td>
                </tr>
              ))}
              {contributions.length>0&&(
                <tr style={{background:'var(--red-light)',fontWeight:700}}>
                  <td colSpan={2}>TOTAL ({contributions.length} entries)</td>
                  <td>{fmt(summary.total||0)}</td><td></td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
